import { render } from "./createBox.vue?vue&type=template&id=88e37d9a"
import script from "./createBox.vue?vue&type=script&lang=js"
export * from "./createBox.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__